module.exports = __webpack_public_path__ + "img/avatar6.613e9253.png";